import { Component, Input } from "@angular/core";

@Component({
    selector: "kt-empty-state",
    templateUrl: "./empty-state.component.html",
    styleUrls: ["./empty-state.component.scss"],
})
export class EmptyStateComponent{
    @Input() icon: string | null = null;
    @Input() fileIcon: { src: string; alt?: string } | null = null;
    @Input() heading: string | null = null;
    @Input() content: string | null = null;
    @Input() height: string | null = null;
    @Input() noIconBackground: boolean = false;
    @Input() gap: number | null = null;

    constructor(){}

}